/**
 * BrandService
 *
 * Identidade visual white label para a interface do PDV Desktop.
 * Carrega o brand.json do parceiro (gerado em build) e expõe logo, nome do
 * sistema, cores e dados de suporte. Funciona offline: usa o IPC do Electron
 * e, em fallback, o arquivo estático copiado para media/brand/brand.json.
 */

const DEFAULT_BRAND = {
  brandCode: "nuts",
  productName: "PDV Desktop",
  companyName: "",
  supportName: "",
  supportPhone: "",
  supportEmail: "",
  website: "",
  primaryColor: "#ee7361",
  secondaryColor: "#ffffff",
  copyright: "",
};

const LOGO_PATH = "media/brand/logo.png";
const SPLASH_PATH = "media/brand/splash.png";

let _brand = { ...DEFAULT_BRAND };
let _loaded = null;

async function carregar() {
  if (_loaded) return _loaded;
  _loaded = (async () => {
    try {
      if (typeof window !== "undefined" && window.electronAPI && window.electronAPI.brand) {
        const data = await window.electronAPI.brand.get();
        if (data) _brand = { ...DEFAULT_BRAND, ...data };
        return _brand;
      }
    } catch (e) {
      /* ignora e tenta fallback */
    }
    try {
      const res = await fetch("media/brand/brand.json", { cache: "no-store" });
      if (res.ok) _brand = { ...DEFAULT_BRAND, ...(await res.json()) };
    } catch (e) {
      /* mantém default */
    }
    return _brand;
  })();
  return _loaded;
}

export default {
  carregar,
  get: () => _brand,
  get logo() {
    return LOGO_PATH;
  },
  get splash() {
    return SPLASH_PATH;
  },
  get productName() {
    return _brand.productName;
  },
  get companyName() {
    return _brand.companyName;
  },
};
